import { GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import { getFechamentoControleRfaByFechamentoId, getFechamentoReportPerformaceProject } from '@app/api/fechamento';
import TabelaProjetoOverviewResumo from '../Dashboard/ProjectsOverview/tabelaProjetoOverviewResumo';
import { TabelaProjetoOverViewResult } from '@app/api/tabelaProjetoOverView';
const { Panel } = Collapse;


interface FechamentoProjetoOverViewProps {
    fechamentoId: string;
}


const FechamentoProjetoOverView = (props: FechamentoProjetoOverViewProps) => {

    const { fechamentoId } = props;
    const [resultProjetoOverView, setResultProjetoOverView] = useState<TabelaProjetoOverViewResult[]>()


    useEffect(() => {
        if (fechamentoId) {
            getFechamentoReportPerformaceProject(fechamentoId).then((data) => {
                setResultProjetoOverView(data);
            });
        }
    }, [fechamentoId]);

    return (

        <GridView noform>
            <GridView icon="files-new_by_copy" id={`detalhe`} noform title="PROJECTS | APPROVED">
                <TabelaProjetoOverviewResumo
                    dataSourceResult={resultProjetoOverView}
                    telaFechamento={true}
                    fechamentoId={fechamentoId}
                />
            </GridView>
        </GridView>

    );

}

export default FechamentoProjetoOverView;